/**
 * TaskStatusService
 * Service for TaskStatus entity operations
 * Route: api/task-status
 */
import { CrudService } from '../base/CrudService';
/**
 * TaskStatusService
 * Handles task status CRUD operations
 */
export class TaskStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? TaskStatusService.DEFAULT_SERVICE_PATH,
            basePath: TaskStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
TaskStatusService.DEFAULT_SERVICE_PATH = 'tasks';
TaskStatusService.BASE_PATH = 'api/task-status';
//# sourceMappingURL=TaskStatusService.js.map